module.exports = "<nav [ngClass]=\"visible ? 'cbp-spmenu-open' : ''\"\r\nclass=\"left-menu cbp-spmenu cbp-spmenu-vertical cbp-spmenu-left color-{{environment}}\"\r\n id=\"cbp-spmenu-s1\">\r\n  <ul class=\"nav white\">\r\n    <li>\r\n      <a href=\"/ng5\" class=\"cleanDashboard\">Dashboard</a>\r\n    </li>\r\n    <li *ngFor=\"let item of MenuItems\">\r\n      <a [routerLink]=\"item.Url\" (click)=\"close()\" class=\"cleanDashboard\">{{item.Text}}</a>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n\r\n\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/sideBar/sideBar.component.html
// module id = ./src/app/shared/components/sideBar/sideBar.component.html
// module chunks = main